import React, { Fragment, useState, useReducer, useEffect } from "react";
import Stepper from "./Stepper";
import InitialInformation from "./steps/InitialInformation";
import FrontDocument from "./steps/FrontDocument";
import BackDocument from "./steps/BackDocument";
import SelfieVideo from "./steps/SelfieVideo";
import SelfieVideoDesktop from "./steps/SelfieVideoDesktop";
import CloseSVG from "../assets/images/close.svg";
import FinalStep from "./steps/FinalStep";
import AuraPayLogo from "../assets/images/AuraPayLogo.png";
import {
  sendMessage,
  getDeviceType,
} from "./../Utils";
import CountrySelector from "./steps/CountrySelector";
import DocumentType from "./steps/DocumentType";

const complexStateInitial = {
  frontDocument: null,
  backDocument: null,
  selfieVideo: null,
  documentType: "national-id",
  country: null,
  // .. more states
};

const closeStylesError = {
  maxWidth: "25px",
  position: "absolute",
  alignSelf: "flex-start",
};

function reducer(state, action) {
  switch (action.type) {
    case "frontDocument":
      return { ...state, frontDocument: action.value };
    case "backDocument":
      return { ...state, backDocument: action.value };
    case "selfieVideo":
      return { ...state, selfieVideo: action.value };
    case "documentType":
      return { ...state, documentType: action.value };
    case "country":
      return { ...state, country: action.value };

    // ... more states
    default:
      throw new Error();
  }
}

const StepperForm = (props) => {
  const [state, dispatch] = useReducer(reducer, complexStateInitial);
  const [activeStep, setActiveStep] = useState(1);
  const [deviceType, setDeviceType] = useState();
  const [openFromIframe, setOpenFromIframe] = useState();
  const steps = [
    { title: "Introducción" },
    { title: "Selector País" },
    { title: "Tipo de Documento" },
    { title: "Documento Frontal" },
    { title: "Documento Posterior" },
    { title: "Video de validación" },
    { title: "Finalizar" },
  ];

  if (props.canVideo === false || props.canVideo === undefined) {
    const videoIndex = steps.map((e) => e.title).indexOf("Video de validación");
    steps.splice(videoIndex, 1);
  }

  if(props.country) {
    let countryIndex = steps.map((e) => e.title).indexOf("Selector País");
    steps.splice(countryIndex, 1);
  }

  if (state.documentType === "passport") {
    const backDocIndex = steps.map((e) => e.title).indexOf("Documento Posterior");
    steps.splice(backDocIndex, 1);
  }

  // const handleOnClickStepper = (step) => {
  //   setActiveStep(step);
  // };

  const handleOnClickNext = () => {
    let nextStep = activeStep + 1;
    setActiveStep(nextStep);
  };

  useEffect(() => {
    const deviceType = getDeviceType();
    window === window.parent
      ? setOpenFromIframe(false)
      : setOpenFromIframe(true);
    setDeviceType(deviceType);
  }, []);

  const closePopUp = (e) => {
    e.preventDefault();

    sendMessage("exitedSdk", { data: "exited manually by user" });
  };

  // const onChangeUseReducer = (e) => {
  //   const { name, value } = e.target;
  //   dispatch({ type: name, value });
  // };

  useEffect(() => {
    const deviceType = getDeviceType();
    window === window.parent
      ? setOpenFromIframe(false)
      : setOpenFromIframe(true);
    setDeviceType(deviceType);
  }, []);

  return (
    <Fragment>
      <div className="flex items-center justify-center w-full md:w-3/5 lg:w-1/2 p-2 md:p-6 h-full max-h-full">
        <div className="min-w-full w-full h-full lg:w-1/2 relative">
          {openFromIframe ? (
            <button onClick={closePopUp} className="close-frame absolute top-0 right-0 m-5 cursor-pointer">
              {" "}
              <img alt="Close" src={CloseSVG}></img>
            </button>
          ) : null}
          <div className="bg-white shadow-md px-8 pt-6 pb-8 mb-4 rounded-lg shadow-xl h-full flex flex-col items-center justify-center" style={{ minHeight: "35rem" }}>
            {!props.error ? (
                <div className="w-full h-full flex flex-col items-center justify-center flex-col justify-between py-4 md:px-6 xl:px-20 lg:py-2" style={{ minHeight: "35rem" }}>
                  <img
                    src={AuraPayLogo}
                    className="object-contain md:w-2/4 w-48 self-center"
                    alt="Logo FNA"
                  />

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Introducción") + 1 && (
                    <InitialInformation
                      handleOnClickNext={handleOnClickNext}
                    />
                  )}

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Selector País") + 1 && (
                    <CountrySelector
                      dispatch={dispatch}
                      handleOnClickNext={handleOnClickNext}
                    />
                  )}

                {activeStep ===
                  steps.map((e) => e.title).indexOf("Tipo de Documento") + 1 ? (
                  <DocumentType
                    dispatch={dispatch}
                    handleOnClickNext={handleOnClickNext}
                  />
                ) : null}

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Documento Frontal") + 1 && (
                    <FrontDocument
                      dispatch={dispatch}
                      handleOnClickNext={handleOnClickNext}
                    />
                  )}

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Documento Posterior") + 1 && (
                    <BackDocument
                      dispatch={dispatch}
                      handleOnClickNext={handleOnClickNext}
                    />
                  )}

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Video de validación") + 1 && (
                    deviceType === "desktop" ? (
                      <SelfieVideoDesktop
                        dispatch={dispatch}
                        handleOnClickNext={handleOnClickNext}
                      />
                    ) : (
                      <SelfieVideo
                        dispatch={dispatch}
                        handleOnClickNext={handleOnClickNext}
                      />
                    )
                  )}

                  {activeStep ===
                    steps.map((e) => e.title).indexOf("Finalizar") + 1 && (
                    <FinalStep
                      state={state}
                      // handleSubmitAll={handleSubmitAll}
                      userId={props.userId}
                      contractId={props.contractId}
                      token={props.token}
                      canVideo={props.canVideo}
                      phoneNumberEnc={props.phoneNumberEnc}
                      country={props.country}
                    />
                  )}

                  <Stepper
                    steps={steps}
                    activeStep={activeStep}
                    // onSelect={num => { handleOnClickStepper(num) }}
                    showNumber={false}
                  />

                </div>
            ) : (
              <Fragment>
                {openFromIframe ? (
                  <button onClick={closePopUp} style={closeStylesError}>
                    {" "}
                    <img alt="Close" src={CloseSVG}></img>
                  </button>
                ) : null}
                <div>
                  <p>Validación expirada.</p>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StepperForm;
